// src/utils/logFormatters.js
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export const formatLogDate = (date) => {
  return format(new Date(date), "dd/MM/yyyy 'às' HH:mm:ss", { locale: ptBR });
};

export const formatLogAction = (action) => {
  const actions = {
    CREATE: 'Criação',
    UPDATE: 'Atualização',
    DELETE: 'Exclusão',
    READ: 'Consulta',
    LOGIN: 'Login',
    LOGOUT: 'Logout',
    EXPORT: 'Exportação'
  };
  return actions[action] || action;
};

export const formatLogEntity = (entity) => {
  const entities = {
    USUARIO: 'Usuário',
    INSTITUICAO: 'Instituição',
    ESTUDANTE: 'Estudante',
    CURSO: 'Curso',
    CLASSE: 'Classe',
    PAGAMENTO: 'Pagamento'
  };
  return entities[entity] || entity;
};

export const formatChanges = (oldData, newData) => {
  const changes = [];
  const allKeys = [...new Set([...Object.keys(oldData || {}), ...Object.keys(newData || {})])];

  allKeys.forEach(key => {
    if (oldData?.[key] !== newData?.[key]) {
      changes.push({
        field: key,
        oldValue: oldData?.[key],
        newValue: newData?.[key]
      });
    }
  });

  return changes;
};